import { Collection, CollectionCreatePayload } from '../types/collection';
import { friendlyApiError } from '../utils/apiErrors';
import { authFetch, getApiUrl } from '../utils/api';

export const fetchCollections = async (connectionId: number): Promise<Collection[]> => {
  const response = await authFetch(getApiUrl(`/v1/collections/?connection_id=${connectionId}`), {
    method: 'GET',
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(friendlyApiError(response.status, errorData.detail, 'Your collections'));
  }

  return response.json();
};

export const createCollection = async (payload: CollectionCreatePayload): Promise<Collection> => {
  const response = await authFetch(getApiUrl('/v1/collections/'), {
    method: 'POST',
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(friendlyApiError(response.status, errorData.detail, 'The collection'));
  }

  return response.json();
};
